/* eslint-disable */
import React from 'react';
import { Button, Input, Radio } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { ContentItem, DictionaryContent } from '../styles';

function AdditionalDictionaryContent({
    additionalDictionary,
    additionalSearchText,
    setAdditionalSearchText,
    selectedItems,
    handleAddItem,
    handleChangeItemDataType,
    onCancel,
}) {
    const content = additionalDictionary.content || {};
    const entries = Object.entries(content);

    const filteredEntries = entries.filter(([key, value]) => {
        const searchLower = additionalSearchText.toLowerCase();
        const keyMatch = key.toLowerCase().includes(searchLower);
        const valueStr = typeof value === 'object' ? JSON.stringify(value) : String(value);
        const valueMatch = valueStr.toLowerCase().includes(searchLower);
        return keyMatch || valueMatch;
    });

    const selectedFromThis = selectedItems.find(
        (item) => item.dictionaryId === additionalDictionary.id,
    );

    return (
        <div style={{ marginTop: 16, padding: 16, background: '#f5f5f5', borderRadius: 4 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <h4 style={{ margin: 0 }}>
                    {additionalDictionary.name}
                    {additionalDictionary.external_integration_key && (
                        <span style={{ fontSize: '12px', color: '#666', marginLeft: 8 }}>
                            (ключ:
                            {' '}
                            {additionalDictionary.external_integration_key}
                            )
                        </span>
                    )}
                </h4>
                <Button size="small" onClick={onCancel}>
                    Отмена
                </Button>
            </div>

            <div style={{ marginBottom: 12 }}>
                <Input
                    placeholder="Поиск по ключу или значению..."
                    prefix={<SearchOutlined />}
                    value={additionalSearchText}
                    onChange={(e) => setAdditionalSearchText(e.target.value)}
                    allowClear
                />
            </div>

            <DictionaryContent style={{ maxHeight: 300 }}>
                {filteredEntries.length === 0 ? (
                    <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
                        Ничего не найдено
                    </div>
                ) : (
                    filteredEntries.map(([key, value]) => {
                        const isSelected = selectedItems.some(
                            (item) => item.dictionaryId === additionalDictionary.id && item.key === key,
                        );

                        return (
                            <ContentItem
                                key={key}
                                selected={isSelected}
                                onClick={() => !isSelected && handleAddItem(additionalDictionary, key, 'value')}
                                style={{ cursor: isSelected ? 'not-allowed' : 'pointer', opacity: isSelected ? 0.6 : 1 }}
                            >
                                <div>
                                    <strong>Ключ:</strong>
                                    {' '}
                                    {key}
                                </div>
                                <div>
                                    <strong>Значение:</strong>
                                    {' '}
                                    {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                </div>
                                {isSelected && (
                                    <div style={{ marginTop: 4, color: '#52c41a', fontSize: '12px' }}>
                                        ✓ Уже выбрано
                                    </div>
                                )}
                            </ContentItem>
                        );
                    })
                )}
            </DictionaryContent>

            {selectedFromThis && (
                <div
                    style={{
                        marginTop: 12,
                        padding: 12,
                        background: '#e6f7ff',
                        border: '1px solid #91d5ff',
                        borderRadius: 4,
                    }}
                >
                    <div style={{ fontWeight: 'bold', marginBottom: 8, color: '#1890ff' }}>
                        ✓ Выбран из этого справочника:
                    </div>
                    <div style={{ marginBottom: 4 }}>
                        <strong>{selectedFromThis.integrationKey || selectedFromThis.key}:</strong>
                        {' '}
                        {selectedFromThis.dataType === 'key'
                            ? selectedFromThis.key
                            : (typeof selectedFromThis.value === 'object'
                                ? JSON.stringify(selectedFromThis.value)
                                : String(selectedFromThis.value)
                            )
                        }
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                        Сохранить:
                        <Radio.Group
                            size="small"
                            value={selectedFromThis.dataType}
                            onChange={(e) => {
                                const index = selectedItems.findIndex(
                                    item => item.dictionaryId === additionalDictionary.id,
                                );
                                if (index !== -1) {
                                    handleChangeItemDataType(index, e.target.value);
                                }
                            }}
                            style={{ marginLeft: 8 }}
                        >
                            <Radio.Button value="key">Ключ</Radio.Button>
                            <Radio.Button value="value">Значение</Radio.Button>
                        </Radio.Group>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdditionalDictionaryContent;
